import React from 'react';
import {Button, Col, Form, Row, Typography} from 'antd';
import * as Yup from 'yup';
import {Formik} from "formik";
import {
  CodeSingleFastInput,
  DateInput,
  TextAreaInput,
  TextInput,
  UserSelectInput
} from "../../Boilerplate/formikComponents";
import {cloneDeep} from "lodash";
import {handleSearch} from "../ProjectForm";

export const TaskForm = props => {
  const { task, projectid, onCancel, onSubmit, userid } = props;
  let initials, edit = false;
  if (task) {
    initials = cloneDeep(task);
    edit = true;
  } else {
    initials = {
      status: 'open',
      owneruserid: userid,
    };
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    }
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };
  return (
    <Formik
      initialValues = {initials}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit && onSubmit(values);
      }}
      validationSchema={Yup.object().shape({
        id: Yup.string().nullable(),
        number: Yup.string(),
        name: Yup.string().required(),
        status: Yup.string().required().default('open'),
      })}
    >
      {props => {
        const {
          values, touched, errors, isSubmitting, handleChange, handleBlur, dirty,
          handleSubmit,
          handleReset,
        } = props;
        return (
          <Form>
            <TextInput {...props} formItemLayout={formItemLayout} label='Title' name='name' placeholder='Enter a title'/>
            <TextInput {...props} formItemLayout={formItemLayout} label='Task #' name='number' placeholder='Enter a number'/>
            {!edit && <Row style={{ marginTop: -24, fontSize: 13 }}>
              <Col xs={24} sm={0} style={{ width: 400 }}>
                <Typography><Typography.Paragraph><Typography.Text type={'secondary'}>
                  cProject will auto generate this if left blank. The Task # is intended to be used as a communication
                  reference, written or verbal. [Example: "John, has Task #22 been
                  closed?"]</Typography.Text></Typography.Paragraph></Typography>
              </Col>
              <Col xs={0} sm={16} offset={8} style={{ width: 400 }}>
                <Typography><Typography.Paragraph><Typography.Text type={'secondary'}>cProject will auto generate this
                  if left blank. The Task # is intended to be used as a communication reference, written or verbal.
                  [Example: "John, has Task #22 been
                  closed?"]</Typography.Text></Typography.Paragraph></Typography>
              </Col>
            </Row>}
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Description' name='description' placeholder='Question...'/>
            <UserSelectInput {...props} formItemLayout={formItemLayout} label='Assigned To' name='owneruserid' onSearch={handleSearch(projectid)}/>
            <CodeSingleFastInput {...props} formItemLayout={formItemLayout} label='Status' name='status' table='taskstatus' defaultValue='open'/>
            <CodeSingleFastInput {...props} formItemLayout={formItemLayout} label='Priority' name='priority' table='taskpriority'/>
            <DateInput {...props} formItemLayout={formItemLayout} label='Due Date' name='duedate'/>

            <Form.Item className='submit-controls' {...tailFormItemLayout}>
              <Button.Group compact>
                <Button onClick={handleSubmit} type='primary'>Save</Button>
                <Button onClick={handleReset}>Clear</Button>
                <Button onClick={onCancel}>Cancel</Button>
              </Button.Group>
            </Form.Item>
          </Form>
        );
      }}
    </Formik>
  );
};


// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/TaskForm.js